//@ts-nocheck

import Image from 'next/image'
import styled, { css } from 'styled-components'
import { Heading, Paragraph } from '../../../atoms/Typography/Typography.styles';

export const HeroTertiaryPreTitleParagraph = styled(Paragraph)`
  text-transform: uppercase;
`;

export const HeroTertiaryTitleHeading = styled(Heading)`
`;


export const HeroTertiarySlide = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column-reverse;

  ${({ theme }) => theme.mediaQuery.lg(`
    width: 100%;
    min-height: ${theme.rem(700)};
    flex-direction: row;
  `)}
`

export const HeroTertiaryImageWrapper = styled.div`
  min-height: ${({ theme }) => theme.rem(380)};
  max-height: ${({ theme }) => theme.rem(400)};
  max-height: 50%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  ${({ theme }) =>
    theme.mediaQuery.md(`
    min-height: ${theme.rem(480)};
    max-height: 50%;
  `)}

  ${({ theme }) =>
    theme.mediaQuery.lg(`
    width: 50%;
    max-height: unset;
  `)}

  &:before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    transform: translateX(100%);
    background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.outside};
    z-index: 10;
  }

  @keyframes coverRTL {
    100% {
      transform: translateX(-100%);
    }
  }
`

export const HeroTertiaryImage = styled(Image)`
  object-fit: cover;
`
export const HeroTertiaryContentWrapper = styled.div`
  height: 50%;
  display: flex;
  flex-direction: column;
  padding-inline: ${({ theme }) => theme.rem(32)};
  padding-top: ${({ theme }) => theme.rem(64)};
  padding-bottom: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.md(`
    padding-inline: ${theme.rem(32)};
  `)}

  ${({ theme }) => theme.mediaQuery.lg(`
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: ${theme.rem(60)};
  `)}
`

export const HeroTertiaryContent = styled.div``
export const HeroTertiaryContentInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(8)};
`
export const HeroTertiaryContentPreTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
`

export const HeroTertiaryContentCtas = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.rem(16)};
  margin-block-start: ${({ theme }) => theme.rem(40)};

  ${({ theme }) =>
    theme.mediaQuery.md(`
    flex-direction: row;
    gap: ${theme.rem(24)}
  `)}
`

export const HeroTertiarySlidePagination = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.rem(16)};
  position: absolute;
  bottom: auto;
  top: 410px;
  left: 50%;
  margin: auto;
  z-index: 1;
  transform: translateX(-50%);

  ${({ theme }) => theme.mediaQuery.md(`
    top: 520px;
  `)}

  ${({ theme }) => theme.mediaQuery.lg(`
    justify-content: flex-start;
    margin: auto auto auto 0;
    bottom: ${theme.rem(32)};
    top: auto;
    left: ${theme.rem(80)};
    transform: translateX(0);
  `)}

  & > .swiper-pagination-bullet {
    min-width: 77.5px;
    max-width: 77.5px;
    height: 4px;
    border: none;
    cursor: pointer;

    ${({ theme }) => theme.mediaQuery.md(`
      min-width: 93px;
      max-width: 93px;
    `)}
  }

  ${({ theme, colorScheme }) => colorScheme && css`
    & > .swiper-pagination-bullet {
      background-color: ${theme.colorScheme[`${colorScheme}`].surface.line};

      &-active {
        background-color: ${theme.colorScheme[`${colorScheme}`].surface.text.accent.base};
      }
    }
  `};
`

export const HeroTertiarySlidePaginationItem = styled.button``

export const HeroTertiary = styled.section`
  width: 100%;
  position: relative;

  ${({ theme }) => theme.mediaQuery.lg(`
    display: flex;
  `)};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  }

  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};

    ${HeroTertiaryContentPreTitle} {
      border: 0.5px solid ${theme.colorScheme[`${colorScheme}`].surface.line};
    }
  `}

  .swiper-slide {
    align-self: stretch;
    // transition-delay: 0.2s!important;
    // opacity: 0;
  }
  
  .swiper-slide-visible {
    opacity: 1;
    
    ${HeroTertiaryImageWrapper} {
      &:before {
        animation: coverRTL .8s ease-out 0s 1 forwards;
      }
    }
  }

  a {
    width: 100%;
  }
`

export const HeroTertiarySwiperWrapper = styled.div`
  ${({ theme }) => theme.mediaQuery.lg(`
    width: 50%;
  `)};
`

export const HeroTertiarySingleItemWrapper = styled.div`
  ${({ theme }) => theme.mediaQuery.lg(`
    width: 50%;
  `)};
`

export const HeroTertiaryIconWrapper = styled.div`
  
`;
